<div class="tab-title">
  <h3>Comments <span *ngIf="commentsList.length">({{commentsList.length}})</span></h3>
</div>
<div class="tab-content">
  <div *ngIf='dataLoading' class="dataLoading">
    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
  </div>

  <ng-container *ngIf="!dataLoading">
    <div class="data-empty m-0" *ngIf="!commentsList.length">
      <p>{{ 'general.NoFound' | translate }}</p>
    </div>
    <ul class="comments-list">
      <li *ngFor="let comment of commentsList; index as i">
        <div class="d-flex justify-content-between">
          <div class="flex-grow-1">
            <div class="user-badge">
              <div class="badge-img">
                <img *ngIf="comment.commentByImage" [src]="comment.commentByImage"
                  (error)="comment.commentByImage = ''" />
                <span *ngIf="!comment.commentByImage" [innerHTML]="comment.commentByName | shortName"></span>
              </div>
              <div class="badge-text flex-grow-1">
                <h4>{{comment.commentByName}}</h4>
                <h6>{{comment.commentDate | date:'medium'}}</h6>

                <div class="comment">
                  <div [innerHTML]="comment.comment | sanitizeHtml"></div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </li>
    </ul>
  </ng-container>
</div>
